import { useLocation, useNavigate } from 'react-router-dom'
import { feedUrl } from '@/urls'

export default () => {
  const location = useLocation()
  const navigate = useNavigate()

  const onCloseModal = () => {
    if (location?.state?.returnUrl) {
      // Normalize accidental double-slashes from older returnUrl joins; keep ?query
      const url = String(location.state.returnUrl).replace(/([^:]\/)\/+/g, '$1')
      navigate(url, { replace: true })
      return
    }
    // Close deterministically onto the page under the modal. history.back()
    // walks through stacked modal entries (direct links, reloads) one by one,
    // leaving the modal visually open after the click.
    const lastNonModalPath = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('lastNonModalPath')
    if (lastNonModalPath) {
      navigate(lastNonModalPath, { replace: true })
    } else if (typeof window !== 'undefined' && window.history.length > 1) {
      navigate(-1)
    } else {
      navigate(feedUrl())
    }
  }

  return {
    close: onCloseModal,
  }
}
